export default function IosAmericanfootballOutline() {
  return (
    <div
      className="ion-icon-ios-americanfootball-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M378.605,133.395C305.902,60.691,189.38,47.998,116.85,48c-38.926,0.001-65.191,3.658-65.191,3.658
		s-29.984,215.227,81.736,326.947C206.099,451.309,322.617,464,395.149,464c38.926,0,65.192-3.658,65.192-3.658
		S490.326,245.116,378.605,133.395z M65.142,65.208C76.137,64.194,94.374,63,116.856,63H117l-0.068-0.071
		c27.167,0,53.167,1.754,77.792,5.22l-126.6,126.581c-1.025-7.283-1.91-14.697-2.64-22.246
		C60.898,125.049,63.398,84.256,65.142,65.208z M143.9,368.102c-23.85-23.852-42.793-54.938-56.304-92.396
		c-6.973-19.332-12.51-40.373-16.57-62.866L212.838,71.05c10.672,1.929,21.064,4.191,31.141,6.804
		c52.027,13.492,93.783,35.708,124.139,66.064c23.851,23.85,42.786,54.928,56.297,92.386c6.974,19.333,12.509,40.375,16.567,62.871
		L299.17,440.986c-10.66-1.93-21.041-4.191-31.104-6.801C216.036,420.696,174.26,398.459,143.9,368.102z M446.861,446.868
		c-10.994,1.012-29.23,2.275-51.71,2.275c-27.192,0-53.225-1.77-77.876-5.25l126.607-126.607c1.024,7.279,1.908,14.688,2.638,22.233
		C451.108,386.956,448.606,427.817,446.861,446.868z"/>
	<polygon points="307.304,317.847 329.929,340.479 301.275,369.131 312.59,380.445 380.471,312.564 369.157,301.25 340.436,329.971 
		317.811,307.34 346.527,278.623 335.214,267.31 306.499,296.024 283.866,273.386 312.568,244.684 301.255,233.37 272.555,262.07 
		249.929,239.439 278.626,210.742 267.312,199.429 238.618,228.124 215.987,205.487 244.674,176.8 233.361,165.487 204.676,194.172 
		182.052,171.542 210.734,142.86 199.421,131.547 131.538,199.429 142.852,210.743 171.545,182.049 194.169,204.679 165.478,233.37 
		176.791,244.683 205.48,215.994 228.11,238.631 199.432,267.31 210.745,278.623 239.422,249.946 262.048,272.577 233.374,301.251 
		244.688,312.564 273.359,283.893 295.992,306.531 267.332,335.191 278.646,346.505 	"/>
</g>
</svg>
`,
      }}
    />
  )
}
